import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { fromEvent } from 'rxjs';
import { map, retry, tap } from 'rxjs/operators';
import { AutosaveService, AutosavingStates } from '../services/autosave/autosave.service';
import { NotificationService } from '../services/notification.service';

const onlineChanges$ = fromEvent(window, 'online').pipe(map(() => true));
let snackBarRef: MatSnackBarRef<TextOnlySnackBar> | null = null;
let didDisplayError = false;

function displayError(autosaveService: AutosaveService, notificationService: NotificationService) {
  autosaveService.emit(AutosavingStates.Failed);

  if (!snackBarRef && !didDisplayError) {
    didDisplayError = true;
    snackBarRef = notificationService.openSnackBar('Internet connectivity lost...', 'Ok', null, 99999);
  }
}

function dismissError() {
  didDisplayError = false;

  if (snackBarRef) {
    snackBarRef.dismiss();
    snackBarRef = null;
  }
}

export const retryInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const autosaveService = inject(AutosaveService);
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    retry({
      delay: (error) => {
        if (navigator.onLine) {
          throw error;
        }
        displayError(autosaveService, notificationService);
        return onlineChanges$.pipe(tap(() => dismissError()));
      },
    })
  );
};
